// DOM要素の型定義
type HeaderElements = {
  header: HTMLElement | null;
  hamburgerButton: HTMLElement | null;
  body: HTMLElement | null;
};

// 必要なDOM要素を取得する関数
const getHeaderElements = (): HeaderElements => ({
  header: document.querySelector<HTMLElement>('.js-header'),
  hamburgerButton: document.querySelector<HTMLElement>('.js-hamButton'),
  body: document.querySelector<HTMLElement>('body'),
});

// メニューを開く関数
const openMenu = (
  header: HTMLElement,
  body: HTMLElement,
  hamburgerButton: HTMLElement
): void => {
  header.classList.add('isVisible');
  hamburgerButton.classList.add('isOpen');
  body.classList.add('isHeaderVisible');
};

// メニューを閉じる関数
const closeMenu = (
  header: HTMLElement,
  body: HTMLElement,
  hamburgerButton: HTMLElement
): void => {
  header.classList.remove('isVisible');
  hamburgerButton.classList.remove('isOpen');
  body.classList.remove('isHeaderVisible');
};

// クリックイベントを設定する関数
const setupHeaderToggle = (): void => {
  const elements = getHeaderElements();

  // 要素が存在しない場合は処理を終了
  if (!elements.header || !elements.hamburgerButton || !elements.body) {
    console.error('Required elements not found');
    return;
  }

  // ハンバーガーボタンのクリックイベント
  elements.hamburgerButton.addEventListener('click', () => {
    if (elements.header!.classList.contains('isVisible')) {
      closeMenu(elements.header!, elements.body!, elements.hamburgerButton!);
    } else {
      openMenu(elements.header!, elements.body!, elements.hamburgerButton!);
    }
  });
};

// DOMの読み込みが完了したら実行
document.addEventListener('DOMContentLoaded', setupHeaderToggle);
